import React from 'react';
import PropTypes from 'prop-types';
import { oddFormatter } from 'Utils/decimalFormatter';
import { withMixpanel } from 'Utils/mixpanel';
import Icon from 'Components/Icon';
import { useDispatch } from 'react-redux';
import { openModal } from 'Store/actions';
import { classnames } from 'Utils/classnames';

const CouponBets = ({ couponLegs, mixpanel }) => {
  const dispatch = useDispatch();

  return couponLegs?.map((leg, index) => <div key={ index } className="coupon-bet-item">
    <div className="coupon-bet-item__header">
      <div className="left">
        <Icon iconName="svgBetslipHorse" />
        <span>{ leg?.hippodromeDisplayName }</span>
        ({ `${leg?.raceNo}.Koşu  ${leg?.raceHour}` })
        { leg?.videoUrl && <Icon onClick={ () => {
          dispatch(openModal('tjkMediaPlayerModal', {
            type: 'video', url: leg.videoUrl,
            hippodrome: leg?.hippodromeDisplayName,
            runInfo: `${leg?.raceDate} - ${leg.raceNo}.Koşu`
          },

            mixpanel?.track('Click Watch Race Video', {
              Hippodrome: leg?.hippodromeDisplayName,
              'Page Name': 'Kuponlarım',
              'Race Number List': leg.raceNo,
              'Calendar Date': leg?.raceDate,
            })
          ));
        } }
        className="coupon-detail-game-row__video-icon" iconName="svgVideo" /> }
      </div>
      <div className="right">
        <div className="winners">
          <div className="bet">
            { leg?.legBetTypeName }
            <span>Oran:&nbsp;{ leg?.horses?.some(h=> h.startingPrice === true) ? 'K.O' : oddFormatter(leg?.legFixedOdd) }</span>
          </div>
          { leg.winners?.map((winner, i) => (
            <div key={ i }  className="winner">{ winner.winnerHorseNumber ?? '-' } ({ winner.winnerAgfRank ?? '-' }. AGF)</div>
          )) }
        </div>
        { ['WON', 'LOST'].includes(leg?.status) &&  <Icon iconName={ leg.status === 'LOST' ? 'svgTjkLose' : 'svgTjkWin' } /> }
      </div>
    </div>
    <div className="horses">
      <div className="horse-list">
        { leg?.horses?.map((horse, idx) => (<div key={ idx } className= { classnames({
          'horse-item': true,
          winner: horse?.status === 'WON',
        }) }>
          <div className="horse-no">{ horse?.horseNumber }</div>
          <div className="horse-name">
            <span>
              {
                horse.horseName
              } { horse.finishOrder ? `(${horse.finishOrder}.)` : null } { horse.isNotRunning ? '(Koşmaz)' : '' }
            </span>
            { horse?.message }
          </div>
        </div> )) }
      </div>

    </div>
  </div>);
};

CouponBets.propTypes = {
  couponLegs: PropTypes.array,
  mixpanel: PropTypes.object,
};

export default withMixpanel(CouponBets);
